'use strict';
var arrayFromConstructorAndList = require('../internals/array-from-constructor-and-list');
var typedArraySpeciesConstructor = require('../internals/typed-array-species-constructor');

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/typed-array-from-species-and-list.js
// module id = 660
// module chunks = 0